import { buildApplicationPaths } from 'modules/Router/utils';

import { StatefulRoute } from '../types/router';

export const APPLICATION_ROUTES_PREFIX = '/developer';

export const APPLICATION_PATHS = {
  DEVELOPER_HOME: '/',
  PROFILE: '/profile',
  APPS: '/applications',
  APPLICATION: '/applications/:appUUID/:detailsID' as StatefulRoute<void, 'appUUID'>,
  APPLICATION_DETAILS: '/applications/:appUUID/details',
  APPLICATION_PERMISSIONS: '/applications/:appUUID/permissions',
  APPLICATION_CREDENTIALS: '/applications/:appUUID/credentials',
  REGISTER_APPLICATION: '/applications/register',
  ONBOARDING_DEVELOPMENT: '/onboarding/development',
  TESTS: '/tests',
  WIDGETS: '/widgets',
  WIDGET_DETAILS: '/widgets/:widgetUUID/:detailsID',
  WIDGET_PERMISSIONS: '/widgets/:widgetUUID/permissions',
  WIDGET_UPDATE: '/widgets/:widgetUUID/update',
  REGISTER_WIDGET: '/widgets/register',
  TEAMMATES: '/teammates',
};

export const ROUTER_PATHS = {
  ...buildApplicationPaths(APPLICATION_PATHS, APPLICATION_ROUTES_PREFIX),
  HOME: '/',
  EMBEDDABLES: '/embeddables',
  EMBEDDABLES_DOCS: '/embeddables/docs',
  EMBEDDABELS_CHANGELOG: '/embeddables/changelog',
  REFERENCES: '/docs/references',
  REFERENCES_AUTHENTICATION: '/docs/references#authentication',
  REFERENCES_MERCHANT: '/docs/references#merchant',
  REFERENCES_ORDER: '/docs/references#order',
  REFERENCES_CATALOG: '/docs/references#catalog',
  REFERENCES_FINANCIAL: '/docs/references#financial',
  REFERENCES_SHIPPING: '/docs/references#shipping',
  REFERENCES_REVIEW: '/docs/references#review',
  REFERENCES_GROCERIES: '/docs/references#groceries',
  CHANGELOG: '/docs/changelog',
  COLLECTIONS: '/docs/collections',
  GLOSSARY: '/docs/glossary',
  GUIDES: '/docs/guides',
  GUIDES_AUTHENTICATION: '/docs/guides/authentication',
  GUIDES_MERCHANT: '/docs/guides/merchant/workflow',
  GUIDES_ORDER: '/docs/guides/order/workflow',
  GUIDES_CATALOG: '/docs/guides/catalog',
  GUIDES_FINANCIAL: '/docs/guides/financial',
  GUIDES_SHIPPING: '/docs/guides/shipping',
  GUIDES_REVIEW: '/docs/guides/review',
  GUIDES_GROCERIES: '/docs/guides/groceries',
  GUIDES_GETTING_START: '/docs/guides/getting-started',
  ORDER_WORKFLOW: '/docs/guides/order/workflow',
  ORDER_HOMOLOGATION: '/docs/guides/order/homologation',
  SIGN_UP: '/sign-up',
  SIGN_IN: '/sign-in',
  API_STATUS: '/support/api-status',
  TICKETS: '/support/tickets',
  SUPPORT: '/support',
  FAQ: '/support/faq',
  DEVELOPER_TERMS_OF_USE: '/terms-of-use/developer',
  PARTNER_TERMS_OF_USE: '/terms-of-use/partner',
  INDOOR: '/docs/guides/order/indoor',
  TAKEOUT: '/docs/guides/order/takeout',
  FIRST_STEPS: '/docs/guides#primeiros-passos',
  RATE_LIMIT: '/docs/rate-limit',
};

export const DEVELOPER_MEDIUM = 'https://medium.com/ifood-developer';

export const OLD_DEVELOPER_PORTAL = 'https://developer-deprecated.ifood.com.br';

export const WHITELABEL_URL = 'https://parceiros.ifood.com.br/restaurante/cardapio-digital';
export const EASY_DELIVERY_URL = 'https://blog-parceiros.ifood.com.br/entrega-facil';
